"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompanyStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
//import trans from "../../common/i18n";
//import { Router } from "vue-router";
exports.useCompanyStore = (0, pinia_1.defineStore)("appCompanyStore", {
    state: () => ({
        id: null,
        name: "",
        pdfUrl: "",
    }),
    getters: {},
    actions: {
        async getCompany() {
            const response = await (0, fetch_1.default)(`/api/get/company`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });
            const datas = await response;
            if (datas) {
                this.id = response.id;
                this.name = response.name;
                this.pdfUrl = response.pdfUrl;
            }
        },
    },
});
